export var CGIServerErrorCode;
(function (CGIServerErrorCode) {
    // 离线预拉取数据超出阈值限制
    CGIServerErrorCode[CGIServerErrorCode["ErrOfflineDocDataOutLimit"] = 200058] = "ErrOfflineDocDataOutLimit";
})(CGIServerErrorCode || (CGIServerErrorCode = {}));
